export const dashboard = {
  title: 'Panel główny',
  statisticsTitle: 'Statystyki',
  navigationTitle: 'Szybka nawigacja',
  navigationDescription: 'Przejdź bezpośrednio do wybranej sekcji systemu',
  noSections: 'Brak dostępnych sekcji',
  tilesError: 'Nie udało się załadować kafelków nawigacyjnych',
  sectionsError: 'Nie udało się załadować danych statystycznych',
  sections: {
    dashboardDesc: 'Widok główny z nawigacją i najważniejszymi danymi',
    statisticsDesc: 'Wykresy i statystyki aktywności z ostatnich 30 dni',
    profileDesc: 'Zarządzaj swoim profilem użytkownika',
  },
  chart: {
    criterion: 'Kryterium {position}',
    title: '{name}: najpopularniejsze wartości',
    period: 'Ostatnie 30 dni',
    total: 'Łącznie: {count}',
    values: 'Wartości: {count}',
    mostCommon: 'Najczęściej: {label} ({share}%)',
    noData: 'Brak danych w tym okresie',
  },
} as const
